import {
  Button,
  FormSelect,
  FormTextArea,
  Input,
  Modal,
  PhoneInput,
  ToggleSwitch,
} from '@/components/modules';
import { useMeQuery } from '@/remote/user-management/fetch-me';
import type { User, UserLevel } from '@/types/site';

interface UserEditModalProps {
  isOpen: boolean;
  user: User | null;
  onSave: (user: User) => void;
  onCancel: () => void;
  onUserChange: (user: User) => void;
  onPasswordChangeClick: () => void;
}

export default function UserEditModal({
  isOpen,
  user,
  onSave,
  onCancel,
  onUserChange,
  onPasswordChangeClick,
}: Readonly<UserEditModalProps>) {
  // const [isAddressEdit, setIsAddressEdit] = useState(false);
  const { data: me } = useMeQuery();

  if (!user) return null;

  const handleSave = () => {
    const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (user.email !== '' && !regexEmail.test(user.email)) {
      alert('이메일 형식이 올바르지 않습니다.');
      return;
    }
    onSave(user);
  };

  const handleClose = () => {
    // setIsAddressEdit(false);
    onCancel();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="회원 정보 수정"
      size="4xl"
      maxHeight="max-h-[90vh]"
    >
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Input
            label="이름"
            value={user.name}
            onChange={(e) =>
              onUserChange({
                ...user,
                name: e.target.value,
              })
            }
          />
          <Input
            label="이메일"
            type="email"
            value={user.email}
            placeholder="이메일 주소를 입력하세요"
            onChange={(e) =>
              onUserChange({
                ...user,
                email: e.target.value,
              })
            }
          />
          {/* <Input
            label="기존 주소"
            value={user.fullAddress}
            disabled
            onChange={() => {}}
          />{' '}
          <div className="flex items-end justify-start">
            <Button
              onClick={() => {
                setIsAddressEdit(true);
              }}
              variant="primary"
              size="medium"
              className="w-fit "
            >
              주소 변경하기
            </Button>
          </div>
          <div
            className={`md:col-span-2 transition-all duration-300 ease-in-out overflow-hidden ${
              isAddressEdit
                ? ' opacity-100 transform translate-y-0'
                : 'max-h-0 opacity-0 transform-translate-y-2'
            }`}
          >
            <AddressInput
              className="mb-2"
              label="새 주소"
              onChange={(value) =>
                onUserChange({
                  ...user,
                  fullAddress: value,
                })
              }
            />
          </div> */}
          <PhoneInput
            label="휴대폰번호"
            type="mobile"
            value={user.mobilePhone}
            onChange={(value) =>
              onUserChange({
                ...user,
                mobilePhone: value,
              })
            }
          />
          <PhoneInput
            label="전화번호"
            type="landline"
            value={user.phone}
            onChange={(value) =>
              onUserChange({
                ...user,
                phone: value,
              })
            }
          />
          <ToggleSwitch
            label="SMS 수신여부"
            value={user.smsReceive}
            onChange={(value) =>
              onUserChange({
                ...user,
                smsReceive: value,
              })
            }
          />
          <FormSelect
            label="회원 등급"
            value={user.userLevel}
            onChange={(value) =>
              onUserChange({
                ...user,
                userLevel: value as UserLevel,
              })
            }
            options={[
              { value: 'PUBLIC_OFFICE_MANAGER', label: '관공서 관리자' },
              { value: 'TOWN_MANAGER', label: '마을 관리자' },
            ]}
          />
          <Input
            label="아이디"
            value={user.loginId}
            onChange={() => {}} // readOnly이므로 빈 함수
            readOnly
          />
          {(me.userLevel === 'SUPER_ADMINISTRATOR' ||
            me.userLevel === 'HEADQUARTERS_MANAGER') && (
            <div className="flex items-end justify-start">
              <Button
                type="button"
                onClick={onPasswordChangeClick}
                variant="primary"
                size="medium"
              >
                비밀번호 변경
              </Button>
            </div>
          )}
          <FormTextArea
            label="설명"
            value={user.description}
            onChange={(value) =>
              onUserChange({
                ...user,
                description: value,
              })
            }
            placeholder="회원에 대한 설명을 입력하세요"
            maxLength={500}
            className="md:col-span-2"
          />
        </div>

        <div className="flex space-x-3 pt-6">
          <Button
            onClick={handleSave}
            variant="primary"
            size="medium"
            fullWidth
          >
            변경사항 저장
          </Button>
          <Button
            onClick={onCancel}
            variant="secondary"
            size="medium"
            fullWidth
          >
            취소
          </Button>
        </div>
      </div>
    </Modal>
  );
}
